export default __webpack_public_path__ + "static/media/mail-check.bd229e12.svg";